import React from 'react'


const About = () => {
  return (
    <div>
        
      <h1>my name is about.</h1>
    </div>
  )
}

export default About;
